import { render, staticRenderFns } from "./TableEmpty.vue?vue&type=template&id=c6a8a0c8&scoped=true&"
import script from "./TableEmpty.vue?vue&type=script&lang=js&"
export * from "./TableEmpty.vue?vue&type=script&lang=js&"
import style0 from "./TableEmpty.vue?vue&type=style&index=0&id=c6a8a0c8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a8a0c8",
  null
  
)

export default component.exports